import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import PostlistBanner from "./postListBanner";
import { useDocumentData } from "react-firebase-hooks/firestore";
import * as firebase from "firebase/app";
import PostList from "./postList";
import NewPost from "./profil/newPost";

const Search = (props) => {
  const [selectPlatform, setSelectPlatform] = useState("");
  const [selectLevel, setSelectLevel] = useState("");
  const [selectGame, setSelectGame] = useState(props.searchGame.game);
  const [selectGameId, setSelectGameId] = useState(props.searchGame.game_id);

  const [newPostTrigger, setNewPostTrigger] = useState();

  const [gameData] = useDocumentData(
    firebase.firestore().doc(`games/${selectGameId}`)
  );

  return (
    <section className="pageSearch  container">
      <PostlistBanner
        setNewPostTrigger={setNewPostTrigger}
        gameList={props.gamesList}
        selectGameId={selectGameId}
        disconnected={props.disconnected}
        setSelectGameId={setSelectGameId}
        setSelectGame={setSelectGame}
        gamesList={props.gamesList}
      />
      {newPostTrigger && (
        <NewPost
          valueUserInfo={props.valueUserInfo}
          userId={props.userId}
          setNewPostTrigger={setNewPostTrigger}
          postValue={false}
          selectGameId={selectGameId}
        />
      )}
      <div className="pageSearch__content ">
        <div className="pageSearch__colLeft">
          <div className="filtres">
            <div className="filtres__el">
              <h3 className="filtres__title">Platforme</h3>
              <Dropdown>
                <Dropdown.Toggle className="filtres__dropdown" as={"button"}>
                  {!selectPlatform ? "Platforme" : selectPlatform}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Header>Choisir une platforme</Dropdown.Header>
                  <ul>
                    <Dropdown.Item
                      as={"li"}
                      onClick={() => setSelectPlatform("")}
                    >
                      Aucun
                    </Dropdown.Item>
                    {gameData &&
                      gameData.consoles.map((value, key) => (
                        <Dropdown.Item
                          as={"li"}
                          onClick={() => setSelectPlatform(value)}
                          key={key}
                        >
                          {value}
                        </Dropdown.Item>
                      ))}
                  </ul>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filtres__el">
              <h3 className="filtres__title">Niveau / Rang</h3>
              <Dropdown>
                <Dropdown.Toggle className="filtres__dropdown" as={"button"}>
                  {!selectLevel ? "Niveau" : selectLevel}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Header>Choisir un Niveau</Dropdown.Header>
                  <ul>
                    <Dropdown.Item as={"li"} onClick={() => setSelectLevel("")}>
                      Aucun
                    </Dropdown.Item>
                    {gameData &&
                      gameData.levels.map((value, key) => (
                        <Dropdown.Item
                          as={"li"}
                          onClick={() => setSelectLevel(value)}
                          key={key}
                        >
                          {value}
                        </Dropdown.Item>
                      ))}
                  </ul>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        <div className="pageSearch__colRight posts">
          <PostList
            disconnected={props.disconnected}
            selectGame={selectGame}
            selectLevel={selectLevel}
            selectPlatform={selectPlatform}
            valueUserInfo={props.valueUserInfo}
            userId={props.userId}
            setAuthFormTrigger={props.setAuthFormTrigger}
            setLogInTrigger={props.setLogInTrigger}
          />
        </div>
      </div>
    </section>
  );
};

export default Search;
